const getVehicleByVIN = (cars: any, VIN: string) => {
  const theVehicle = cars?.find(
    (car: { chassisNumber: string }) => car.chassisNumber === VIN
  );

  return theVehicle ? theVehicle : null;
};

export default getVehicleByVIN;
